import {
    LOGIN_REQUEST,
    LOGIN_SUCCESS,
    LOGIN_FAILURE,
    LOGOUT_REQUEST,
    LOGOUT_SUCCESS,
    LOGOUT_FAILURE, CHECK_JWT_SUCCESS, CHECK_JWT_FAILURE, CHECK_JWT_REQUEST, SELECT_ROLE_REQUEST
} from "../constants/authenticationActionTypes";
import {decodeJWT} from "../../utils/jwtUtils";
import {toast} from "react-toastify";

const initialState = {
    authToken: "",
    email: "",
    userGroups: [],
    selectedRole: "",
    loadedCheckJWT: false,
    loading: {
        login: false,
        logout: false,
        checkJWT: false
    },
    error: null,
    authenticator: {
        enabled: false,
        provisioningURI: ""
    }
}

const authenticationReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOGIN_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, login: true },
                authenticator: {
                    ...state.authenticator,
                    enabled: false,
                    provisioningURI: ""
                },
                error: null
            };
        case LOGIN_SUCCESS: {
            toast(action.payload.msg);

            const decodedToken = action.payload.authToken && action.payload.authToken !== 'BFF_SESSION'
                ? decodeJWT(action.payload.authToken)
                : null;

            const user = action.payload.user || {};

            return {
                ...state,
                loading: { ...state.loading, login: false },
                authToken: action.payload.authToken,
                email: user.email || (decodedToken ? decodedToken.Email : ""),
                userGroups: user.groups || (decodedToken ? decodedToken.Groups : []),
                authenticator: {
                    ...state.authenticator,
                    enabled: action.payload.authenticatorEnabled,
                    provisioningURI: action.payload.provisioningURI
                }
            };
        }
        case LOGIN_FAILURE:
            toast(action.payload.error);
            return { ...state,
                loading: { ...state.loading, login: false },
                error: action.payload.error
            };
        case LOGOUT_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, logout: true },
                error: null
            };
        case LOGOUT_SUCCESS:
            return {
                ...state,
                loading: { ...state.loading, logout: false },
                authToken: "",
                email: "",
                userGroups: []
            };
        case LOGOUT_FAILURE:
            return { ...state,
                loading: { ...state.loading, logout: false },
                error: action.payload
            };
        case CHECK_JWT_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, checkJWT: true },
                error: null
            };
        case CHECK_JWT_SUCCESS: {
            const decodedCheckToken = action.payload.authToken && action.payload.authToken !== 'BFF_SESSION'
                ? decodeJWT(action.payload.authToken)
                : null;

            const user = action.payload.user || {};

            return {
                ...state,
                loading: { ...state.loading, checkJWT: false },
                loadedCheckJWT: true,
                authToken: action.payload.authToken,
                email: user.email || (decodedCheckToken ? decodedCheckToken.Email : ""),
                userGroups: user.groups || (decodedCheckToken ? decodedCheckToken.Groups : [])
            };
        }
        case CHECK_JWT_FAILURE:
            return {
                ...state,
                loading: { ...state.loading, checkJWT: false },
                authToken: "",
                email: "",
                userGroups: [],
                loadedCheckJWT: true,
                error: action.payload.error
            };
        case SELECT_ROLE_REQUEST:
            return {
                ...state,
                selectedRole: action.payload.selectedRole
            };
        default:
            return state;
    }
}

export default authenticationReducer;